import { panelActionCellProps } from 'components/RowGroup'
import RowGroup, { Row, Header, Cell } from './RowGroup'

export default Object.assign(RowGroup, {
  Row: Row,
  Cell: Cell,
  HeadingCell: Header,
  CaptionCell: Cell,
})

export { panelActionCellProps }
